module.exports = __webpack_public_path__ + "static/media/approved-authorization.3385aac3.svg";